<script>
import {mapGetters} from "vuex";

export default {
    props: ['section'],
    name: "HeaderMobileSection",
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
            user: window.laravel.user,
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster,
        };
    },
    computed: {
        isNotUser() {
            return this.isAdmin || this.isPartner || this.isMaster
        }
    },
    methods: {
        redirect(href) {
            return location.href = window.laravel.appUrlByLocale + window.laravel.prefix + href;
        },
        isUserTree(page) {
            return !(page.href === '/cabinet/tree' && (this.isAdmin || this.isPartner || this.isMaster))
        },
        isLastChild(page) {
            return (page.href === '/familytree#faq' || page.href === '/cabinet/tree') && this.isNotUser
        },
        ...mapGetters('auth', [
            'isAuth'
        ]),
        iconPlusVisible(page){
            return page.href === '/create/tariffs' || page.href === '/cabinet/page/add'
        },
        linkAbout(){
            if(this.section.href === '/about-service') {
                this.redirect('/about-service')
            }
        }
    }
}
</script>

<template>
    <li class="header__mobile-section"
         @click.stop="$emit('showSection', section)"
         v-if="!section.isBurgerMenu"
        :class="{ active: section.active }">
        <div class="header__mobile-section-name-wrapper" @click="linkAbout()">
            <div class="header__mobile-section-name-wrapper--content">
                <svg v-if="section.isShowIcon" class="header__mobile-icon" width="21" height="21">
                    <use :href="'/assets/front/img/sprite.svg#'+section.icon"></use>
                </svg>

                <p class="header__mobile-section-name"
                   :class="{ 'header__mobile-section-name--active': section.active }"
                   @click.prevent.stop="(section.active && section.href) ? redirect(section.href) : $emit('showSection', section)">
                    {{ section.name }}
                </p>

            </div>
            <div
                class="btn header__mobile-section-arrow"
                :class="{ active: section.active }"
                @click.stop="$emit('showSection', section)"
            >
                <svg v-if="section.active && section.isShowIcon" width="10" height="10">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-up"></use>
                </svg>
                <svg v-if="!section.active && section.isShowIcon" width="10" height="10">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                </svg>
            </div>
        </div>

        <div class="header__mobile-section-pages" v-if="section.active && section.pages.length">
            <a
                v-if="!page.auth || (user && page.auth)"
                class="header__mobile-section-page-wrapper"
                :href="domain + prefix + page.href"
                 :class="{'header__mobile--create-page': page.button && isUserTree(page)}"
                 v-for="page in section.pages"
            >
                <svg v-if="iconPlusVisible(page)" width="11" height="11">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-plus_nav"></use>
                </svg>
                <a class="header__mobile-section-page" :class="{'header__mobile-last-child': isLastChild(page)}" @click="$emit('close')" >
                  <span v-if="isUserTree(page)">{{ page.name }}</span>
                </a>
            </a>
        </div>
    </li>
</template>

<style scoped>

</style>
